module.exports = __webpack_public_path__ + "static/media/sticky_XI.b25fbd73.png";